// src/pages/DeviceTypeManagement/tabs/OverviewTab.jsx
import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Divider
} from '@mui/material';

const OverviewTab = ({ deviceType, onChange }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Device Type Overview
      </Typography>
      <Divider sx={{ mb: 3 }} />

      {/* Device Type Information */}
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Device Type Information
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              fullWidth
              label="Friendly Name"
              value={deviceType.friendlyName || ''}
              onChange={(e) => onChange({ friendlyName: e.target.value })}
              helperText="Technical identifier for the device type"
            />

            <TextField
              fullWidth
              label="Front-End Name"
              value={deviceType.FrontEndName || ''}
              onChange={(e) => onChange({ FrontEndName: e.target.value })}
              helperText="Display name shown to users (optional)"
            />
          </Box>
        </CardContent>
      </Card>

      {/* Metadata */}
      <Card sx={{ mt: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Metadata
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Device Type ID
              </Typography>
              <Typography variant="body1" fontWeight="500">
                {deviceType.id}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Created At
              </Typography>
              <Typography variant="body1">
                {deviceType.created_at ? new Date(deviceType.created_at).toLocaleString() : 'N/A'}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Last Updated
              </Typography>
              <Typography variant="body1">
                {deviceType.updated_at ? new Date(deviceType.updated_at).toLocaleString() : 'N/A'}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OverviewTab;
